module.exports = __webpack_public_path__ + "img/arrow-back-white.5c5bcc31.svg";